import React from "react";
import moment from "moment";
import { IPage } from "../../../../interfaces/models/models/paginated-response.model";
import { IPaginationPayload } from "../../../../interfaces/shared/IPaginationPayload";
import { IReservationsTable } from "../../../../interfaces/reservations/IReservationsProps";
import { onFormatPaymentStatus } from "../../../../utils/constants/payment-statuses";
import MakeCall from "../MakeCall";
import TableActions from "../../../../shared/table/table-actions";
import Button from "../../../../shared/button";
import Table from "../../../../shared/table";

const tableColumns = ["Action", "Reservation Id", "Guest Information", "Hotel Details", "Booking Details", "Payment Status", "Created by", "Guest Personal Info", "Actions"];

interface IReservationDetails {
  rows: IReservationsTable[];
  paginationData?: IPage;
  rowsLoading: boolean;
  onClickShowGuestInfo: (data: any, reservationId?: string) => void;
  setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
  onSeeReservationDetails: (data: any) => void;
  onDownloadInvoice: (invoiceUrl: string) => void;
}

const ReservationsTable = ({
  rows,
  paginationData,
  rowsLoading,
  onClickShowGuestInfo,
  setPaginationState,
  onSeeReservationDetails,
  onDownloadInvoice,
}: IReservationDetails) => {
  return (
    <Table
      columns={tableColumns}
      paginationData={paginationData}
      setPaginationState={setPaginationState}
      containerStyle="!mt-0"
    >
      {rowsLoading ? (
        <>
          {[...Array(4)].map((x, i) => {
            return (
              <tr key={i}>
                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                  return (
                    <td key={j} className="td-1 !min-w-[100%] text-center py-5">
                      <span></span>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </>
      ) : (
        <>
          {rows?.length > 0 &&
            rows?.map((row, idx: number) => {
              const value = onFormatPaymentStatus(row?.paymentDetails?.paymentStatus)?.name
              const text = onFormatPaymentStatus(row?.paymentDetails?.paymentStatus)?.text || 'text-black'
              const item = <div className={`flex flex-row justify-center text-center ${text} text-sm font-medium`}>{value || ''}</div>
              return (
                <tr key={idx} className="bg-white border-b hover:bg-gray-50">
                  <td className="px-5 py-4">
                    {row.guestDetails && (
                      <MakeCall
                        customer={row.guestDetails.name}
                        phoneNumber={row.guestDetails.phone}
                      />
                    )}
                  </td>
                  <td className="px-5 py-4"><div className="w-20 break-words">{row?._id}</div></td>
                  <td className="px-5 py-4">
                    {row.guestDetails && (
                      <div className='w-40 break-words'>
                        {row.guestDetails.name} <br />
                        {row.guestDetails.email} <br />
                        {row.guestDetails.phone}
                      </div>
                    )}
                  </td>
                  <td className="px-5 py-4">
                    {row.hotelDetails.hotelName} (
                    {row.hotelDetails.hotelAddress})
                  </td>
                  <td className="px-5 py-4 w-80">
                    <div className="w-48">
                      {row?.reservationDetails.roomType} <br />
                      Room {row?.reservationDetails.roomNumber} <br />
                      {Boolean(row?.reservationDetails.numberOfGuests) && (
                        <>
                          {" "}
                          Number of guests:{" "}
                          {row?.reservationDetails.numberOfGuests} <br />
                        </>
                      )}
                      Check-In on{" "}
                      {moment(row.reservationDetails.checkinDate).format(
                        "DD/MM/YYYY"
                      )}{" "}
                      <br />
                      Check-out on{" "}
                      {moment(row.reservationDetails.checkoutDate).format(
                        "DD/MM/YYYY"
                      )}
                    </div>
                  </td>
                  <td className="px-5 py-4">
                    {item}
                  </td>
                  <td className="px-5 py-4">
                    {row?.createdBy} <br />
                    {moment(row?.updatedAt).format("DD/MM/YYYY HH:mm")}
                  </td>
                  <td className="px-5 py-4 min-w-[150px]">
                    <Button
                      label={'Guest Info'}
                      className="btn-primary-rounded-less"
                      onClickButton={() => onClickShowGuestInfo(row?.guestPersonalInfo || '', row?._id)}
                    />
                  </td>
                  <td className="px-5 py-4">
                    <div className="flex flex-row items-center">
                      <div data-qa='reservation-details' onClick={() => (row?._id) && onSeeReservationDetails(row)}>
                        <img title={'View Details'} alt='reservation details' src={'/assets/table-actions/visibility.svg'} className={'min-w-[20px] w-[20px] object-contain cursor-pointer mr-2'} />
                      </div>
                      {row?.paymentDetails?.invoiceUrl &&
                        <TableActions>
                          <div
                            onClick={() => onDownloadInvoice(row?.paymentDetails?.invoiceUrl)}
                            className='py-2 px-4 cursor-pointer flex flex-row items-center align-flex-start  hover:bg-[#f4f4f4]'
                            role='none'>
                            <Button
                              label={'Download Invoice'}
                              dataQa={'download-invoice'}
                              className={`btn-primary-text-underline !no-underline !font-normal cursor-pointer`}
                            />
                          </div>
                        </TableActions>
                      }
                    </div>
                  </td>
                </tr>
              );
            })}
        </>
      )}
    </Table>
  );
};

export default ReservationsTable;
